export const getStyles = () => {
    const styles = {
        timer: { 
            mb: 4,
            position: 'relative', 
            display: 'flex', 
            justifyContent: 'center', 
            textAlign: 'center' 
        },
        progress: {
            position: "absolute"
        }
    };
    return styles;
}